import React from 'react';
import PropTypes from 'prop-types';
import './TableModal.scss';
import BaseModal from '../BaseModal/BaseModal';
import Table from '../../Table/Table';
import { DEFAULTS, SORT_DIRECTION } from './constants';

const TableModal = ({
  isOpen,
  modalTitle,
  subtitle,
  data = [],
  columns = [],
  onRowClick,
  onCancel,
  emptyMessage = DEFAULTS.emptyMessage,
  searchPlaceholder = DEFAULTS.searchPlaceholder,
  width = DEFAULTS.width,
  height = DEFAULTS.height,
  defaultSort,
  isLoading = false,
  hideSubmitButton = true,
  searchableFields = [],
}) => (
  <div className="table-modal-component">
    <BaseModal
      width={width}
      height={height}
      modalTitle={modalTitle}
      isOpen={isOpen}
      onSubmit={() => {}} // No submit button for table modals
      onCancel={onCancel}
      onXClick={onCancel}
      onEscKeyPress={onCancel}
      isLightTheme={true}
      hideSubmitButton={hideSubmitButton}
      submitLabel=""
    >
      <div className="table-modal-content">
        {subtitle && <div className="modal-subtitle">{subtitle}</div>}

        <Table
          data={data}
          columns={columns}
          searchPlaceholder={searchPlaceholder}
          searchableFields={searchableFields}
          defaultSort={defaultSort}
          emptyMessage={emptyMessage}
          isLoading={isLoading}
          onRowClick={onRowClick}
          className="table-modal-table"
        />
      </div>
    </BaseModal>
  </div>
);

TableModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  data: PropTypes.array,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      sortable: PropTypes.bool,
      template: PropTypes.func,
      className: PropTypes.string,
      width: PropTypes.string,
      showTooltip: PropTypes.bool,
      format: PropTypes.string,
    })
  ).isRequired,
  onRowClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  emptyMessage: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  isLoading: PropTypes.bool,
  hideSubmitButton: PropTypes.bool,
  defaultSort: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.oneOf([SORT_DIRECTION.ASC, SORT_DIRECTION.DESC]),
  }),
  searchableFields: PropTypes.arrayOf(PropTypes.string),
};

TableModal.defaultProps = {
  data: [],
  emptyMessage: DEFAULTS.emptyMessage,
  searchPlaceholder: DEFAULTS.searchPlaceholder,
  width: DEFAULTS.width,
  height: DEFAULTS.height,
  isLoading: false,
  searchableFields: [],
};

export default TableModal;
